<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X2hfUz/tc-custom/9789948744542.jpg?1731054501067" alt="This image is the cover for the book نبض من أثير"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">نبض من أثير
      </h1>
      <p class="bookDescription body article font2">
        <p>"في قصَّتنا حوارٌ بينَ مَن باعَ الشمسَ واشترى النسيان بين ماضٍ كان وحاضرٍ مِن وحي الخيالِ وإن سألوني عنكَ أخبرتُهم أنَّكَ تائهٌ في حوارِ قصَّتنا وإن سألوني عن حبِّكَ أجابَ صَمتي بسِنينَ مِن التوقِ ماذا أقولُ ونحنُ بيننا حوارٌ؟! تمرُّ الأيامُ ونبقى تدورُ الشُّهورُ والسنواتُ مِن حولنا وحبُّنا لا يعترفُ بروزنامةٍ أو ساعة في قصَّتنا عشقُ العيونِ أغنياتٌ بينَ الجفنِ والعينِ في قصَّتنا لستَ نِصفي الآخَر بل أنتَ كلُّ جزءٍ مِنِّي أنتَ أهمُّ انتصاراتي".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        بولا بولس ربيز (شاعرة الياسمين)
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05820bd9